import immutableStore from 'alt-utils/lib/ImmutableUtil';
import alt from 'components/Dispatcher';
import {Record} from 'immutable';
import CrmInternalActivityActions from 'actions/crm-opp-ui/CrmInternalActivityActions';

@immutableStore
class CrmInternalActivityStore {
  constructor() {
    this.state = new Record({
      activity: null,
      activityLoading: false,
      activityLoaded: false,
    })();

    this.bindActions(CrmInternalActivityActions);
  }

  onFetchActivity(id) {
    this.setState({
      activity: null,
      activityLoading: true,
      activityLoaded: false,
    });
  }

  fetchActivitySuccess(activity) {
    this.setState({
      activity,
      activityLoading: false,
      activityLoaded: true,
    });
  }

  fetchActivityError(activity) {
    console.warn(activity);
    this.setState({
      activity: null,
      activityLoading: false,
      activityLoaded: true,
    });
  }

  clearActivity() {
    this.setState({
      activity: null,
      activityLoading: false,
      activityLoaded: false,
    });
  }
}
export default alt.createStore(CrmInternalActivityStore, 'CrmInternalActivityStore');
